import { useEffect, useMemo } from "react";
import { useAppState } from "../context";
import { EditableTextsType, EditableTextType } from "../types";
import { fetchJson } from "./fetch";
import { FormattedText } from "./formatted-text";

export const EditableTextBlock = ({
    definedName,
    title = '',
    children,
}: {
    definedName: string;
    title?: string;
    children: string | string[];
}) => {
    
    const normalizedChildren = useMemo(() => {
        return Array.isArray(children) ? children.join('\n\n') : children;
    }, [children]);

    const text = useEditableText(definedName, normalizedChildren, title);

    return (
        <>
            <FormattedText text={text} />
        </>
    )
    
};

export const useEditableText = (definedName: string, content: string, title?: string) => {
    const [texts, setTexts] = useAppState<EditableTextsType>('texts');
    const text = texts[definedName]?.content ?? content;

    

    useEffect(() => {
        if (texts[definedName] !== undefined) {
            return;
        }

        fetchJson<{success: boolean, data: EditableTextType}>(`/api/editable-text`, {
            method: 'POST',
            body: JSON.stringify({
                definedName,
                title,
                content: text,
            }),
        }).then(({json: {data}}) => {
            setTexts(prev => ({ 
                ...prev,
                [definedName]: data
            }));
        });

    }, [texts]);

    return text;
};

export default EditableTextBlock; 